import { LocalStorage } from './LocalStorageAbstract';

export class LocalStorageMemory extends LocalStorage {
  private db: Record<string, any> = {};

  async put<T = unknown>(key: string, value: T) {
    this.db[key] = value;
    return value;
  }

  async get<T = unknown>(key: string) {
    return this.db[key] as T;
  }

  async delete(key: string) {
    delete this.db[key];
  }

  async clear() {
    this.db = {};
  }
}
